export const YOUTUBE_IFRAME_API_URL = 'https://www.youtube.com/iframe_api'
export const YOUTUBE_IFRAME_API_SCRIPT_SELECTOR = 'script[src*="youtube.com/iframe_api"]'
export const YOUTUBE_IFRAME_API_SCRIPT_REGEX = /(?:^|\/\/)(?:www\.)?youtube\.com\/iframe_api(?:$|[?#/])/i

export const SOUNDCLOUD_WIDGET_URL = 'https://w.soundcloud.com/player'
export const SOUNDCLOUD_TRACK_API = 'https://api.soundcloud.com/tracks'
export const SOUNDCLOUD_WIDGET_API_URL = `${SOUNDCLOUD_WIDGET_URL}/api.js`
export const SOUNDCLOUD_WIDGET_API_SCRIPT_SELECTOR = 'script[src*="soundcloud.com/player/api"]'
export const SOUNDCLOUD_WIDGET_API_SCRIPT_REGEX = /(?:^|\/\/)(?:w\.)?soundcloud\.com\/player\/api(?:\.js)?(?:$|[?#/])/i